import React from "react";
import InsightsIcon from "@mui/icons-material/Insights";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
    SectionCard,
    ProgressMeter,
    Skeleton,
} from "../../../shares/dashboard/DashboardWidgets";

/**
 * "How am I doing?" - the three measures this API actually supports, on one
 * comparable scale.
 *
 * Exam and assignment averages are percentages. Attendance is derived from
 * the absences and total returned by classroom-box.
 */

/** Attendance below this reads as a problem worth flagging. */
const ATTENDANCE_WARNING = 80;
const ABSENCE_LIMIT = 3;

const scoreTone = (value, max) => {
    if (value === null || value === undefined) return "neutral";
    const percent = (value / max) * 100;
    if (percent >= 75) return "success";
    if (percent >= 50) return "warning";
    return "danger";
};

export default function ProgressPanel({
    examAverage,
    assignmentAverage,
    attendance,
    loading,
    index = 0,
}) {
    const showAbsenceWarning =
        attendance && attendance.absent > ABSENCE_LIMIT;

    return (
        <SectionCard
            title="پیشرفت تو"
            description="یک نگاه کلی به عملکردت"
            icon={InsightsIcon}
            index={index}
        >
            {loading && examAverage === null && assignmentAverage === null ? (
                <div className="flex flex-col gap-lg">
                    {[0, 1, 2].map((key) => (
                        <Skeleton key={key} className="h-[3.2rem] w-full" />
                    ))}
                </div>
            ) : (
                <div className="flex flex-col gap-lg">
                    <ProgressMeter
                        label="میانگین آزمون‌ها"
                        value={examAverage}
                        max={100}
                        suffix=" از ۱۰۰"
                        tone={scoreTone(examAverage, 100)}
                    />
                    <ProgressMeter
                        label="میانگین تکالیف"
                        value={assignmentAverage}
                        max={100}
                        suffix=" از ۱۰۰"
                        tone={scoreTone(assignmentAverage, 100)}
                    />
                    <ProgressMeter
                        label="حضور در کلاس"
                        value={attendance?.rate ?? null}
                        max={100}
                        suffix="٪"
                        tone={
                            attendance && attendance.rate < ATTENDANCE_WARNING
                                ? "warning"
                                : "success"
                        }
                    />

                    {attendance && (
                        <p className="text-sm text-ink-subtle">
                            از {attendance.total.toLocaleString("fa-IR")} جلسه،{" "}
                            {attendance.attended.toLocaleString("fa-IR")} جلسه حاضر
                            بودی.
                        </p>
                    )}

                    {showAbsenceWarning && (
                        <p className="flex items-start gap-xs rounded-card bg-danger-soft p-md text-sm text-danger">
                            <ErrorOutlineIcon
                                sx={{ fontSize: "1.8rem" }}
                                className="shrink-0"
                            />
                            <span>
                                بیش از {ABSENCE_LIMIT.toLocaleString("fa-IR")} جلسه
                                غیبت داشتی. برای جبران با پشتیبانی هماهنگ کن.
                            </span>
                        </p>
                    )}
                </div>
            )}
        </SectionCard>
    );
}
